import { NgModule } from '@angular/core';

import { BytesPipe } from './bytes.pipe';
import { CRSNamePipe } from './crs-name/crsName.pipe';
import { GeoidNamePipe } from './geoid-name/geoidName.pipe';
import { LocalizedDatePipe } from './localized-date/localized-date.pipe';
import { MsToHHMMSSPipe } from './msToHHMMSS/msToHHMMSS.pipe';
import { ResolvePropertyPipe } from './resolve-property/resolve-property.pipe';

@NgModule({
    imports: [],
    declarations: [BytesPipe, LocalizedDatePipe, MsToHHMMSSPipe, GeoidNamePipe, CRSNamePipe, ResolvePropertyPipe],
    exports: [BytesPipe, LocalizedDatePipe, MsToHHMMSSPipe, GeoidNamePipe, CRSNamePipe, ResolvePropertyPipe],
})
export class PipesModule {}
